import React, { useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Select, FormHelperText } from '@material-ui/core'
import { makeStyles, Button, MenuItem, Chip, Input } from '@material-ui/core'
import FormProvider from './FormProvider'
import { getFieldForm } from 'utils/ProjectConfigurationUtil'
import { useAppContext } from 'hooks/useAppContext'

const useStyles = makeStyles((theme) => ({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    cardHeader: {
        "background": theme.palette.primary.main,
        "color": theme.palette.primary.contrastText
    }
}));

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 225,
            width: 250,
        },
    },
}


const AssignFieldForms = ({ onClick, updateForms, currentvalues }) => {
    
    const [st, setSt] = React.useState({ uploadDialog: false, passed: true, formName: currentvalues === undefined ? [] : currentvalues , sampleByCD: {}, formsList: [], confirmation: false, uploadedItem: {}, uploadError: null })
    const updateState = (updatedValues) => setSt(prevState => { return { ...prevState, ...updatedValues } })
    const { selectedProject } = useAppContext();
    const classes = useStyles()

    const handleChange = (event) => {
        const FormId = new Set(st.formName.map(d => d))
        const merged = [...st.formName, ...event.target.value.filter(d => !FormId.has(d))]
        updateState({ formName: merged })
    }
    const addFormsToMaterial = () => {
        updateForms( st.formName.toString(),st.formsList)
    }

    const handleDelete = (chipToDelete) => () => {
        const removeForm = st.formName.filter((chip) => chip !== chipToDelete)
        updateState({ formName: removeForm })
    };

    useEffect(() => {
        getFieldForm({ projectId: selectedProject, isActive: true }).then(r => {
            updateState({ formsList: r.data })
        })
    }, [selectedProject]);

    return (

        <FormProvider.Consumer>
            { open => (
                <Dialog open={open} onClose={onClick} disableBackdropClick maxWidth={'lg'} >
                    <DialogTitle id="form-dialog-title" className={classes.cardHeader}>Select Field Form</DialogTitle>
                    <DialogContent>
                        <Select
                            id="mutiple-chip"
                            style={{ width: "300px", height: "50px" }}
                            multiple
                            value={st.formName}
                            onChange={handleChange}
                            input={<Input id="select-multiple-chip" />}
                            renderValue={(selected) => (
                                <div className={classes.chips}>
                                    {selected.map((value) => (
                                        <Chip key={value} label={value} className={classes.chip}
                                            onDelete={handleDelete(value)} onMouseDown={(event) => {
                                                event.stopPropagation();
                                            }}
                                        />
                                    ))}
                                </div>
                            )}
                            MenuProps={MenuProps}
                        >
                            {st.formsList.map((name) => (
                                <MenuItem key={name.FormId} value={name.TestType} >
                                    {name.TestType}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>select field form to add</FormHelperText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClick} color="primary"> Cancel</Button>
                        <Button onClick={addFormsToMaterial} color="primary">Assign Field Form</Button>
                    </DialogActions>
                </Dialog>
            )
            }
        </FormProvider.Consumer>
    )   
}

export default AssignFieldForms
